import { render } from "./ResultsSingleChoiceQuestion.vue?vue&type=template&id=134e2c7c"
import script from "./ResultsSingleChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./ResultsSingleChoiceQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__